module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-11.5c2cef6c.png";